module.exports = __webpack_public_path__ + "static/media/ICONS-HOME_&_CONSTRUCTION.d1b0decc.svg";